import { Link, useLocation } from "react-router-dom";

import { T } from "@repo/transifex";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { Button, LayoutLogo } from "~/components";
import { useDeviceData } from "~/providers/app";
import { logger } from "~/services/logger";

const NotFoundPage = () => {
  const { pathname } = useLocation();

  const { data: till } = useCurrentTill();
  const { deviceId } = useDeviceData();

  return (
    <LayoutLogo className="flex-col items-center justify-center">
      <p className="mb-4 text-9xl font-bold text-gray-700">Oops!</p>

      <p className="mb-2 text-xl font-bold uppercase">
        <T _str="404 - Page not found" />
      </p>

      <p className="mb-4 w-72 text-center">
        <T _str="The page you are looking for does not exist or may be temporarily unavailable" />
      </p>

      <Link
        to="/home"
        onClick={() => {
          if (till && deviceId) {
            logger.warn("404 - Page not found", {
              pathname,
              till_id: till.id,
              till_device_id: till.deviceId,
              device_id: deviceId
            });
          }
        }}
      >
        <Button variant="danger">
          <T _str="Back to POS" />
        </Button>
      </Link>
    </LayoutLogo>
  );
};

export { NotFoundPage };
